// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IUsCvFrYJ9WCjkikSSlM .tDHFKsbHpyT_48hprz0F{padding:4px 8px;font-size:14px;font-weight:bold;text-transform:none;border:3px solid #fff;animation:dwdW3otJm1SfS4FFCrAj 5s linear infinite}@keyframes dwdW3otJm1SfS4FFCrAj{0%{opacity:1}20%{opacity:.25}40%{opacity:1}60%{opacity:.25}80%{opacity:1}100%{opacity:1}}.q8jVLl0XG1ecY0jskiD6{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;max-width:30vw;color:#fff}.XRoVsfEdTV0gEwaxh51O{opacity:0;bottom:-50px;left:50%}.xvjzxFlPxgyFvSQiO_SH{opacity:1;bottom:20px;left:50%}.pbU0Df5SEKoJSTkMaI5U{opacity:1;bottom:20px;left:50%}.NVc7cUtCDt8lwXPX5zE8{opacity:1;left:50%}.k4JD7sa0Orbyhts2KOEg{opacity:0;left:0}.K8Sp6WQipQYARFhGeTeX{opacity:0;left:50%;bottom:-50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnWrap": "IUsCvFrYJ9WCjkikSSlM",
	"btn": "tDHFKsbHpyT_48hprz0F",
	"blink": "dwdW3otJm1SfS4FFCrAj",
	"btnText": "q8jVLl0XG1ecY0jskiD6",
	"enter": "XRoVsfEdTV0gEwaxh51O",
	"enterActive": "xvjzxFlPxgyFvSQiO_SH",
	"enterDone": "pbU0Df5SEKoJSTkMaI5U",
	"exit": "NVc7cUtCDt8lwXPX5zE8",
	"exitActive": "k4JD7sa0Orbyhts2KOEg",
	"exitDone": "K8Sp6WQipQYARFhGeTeX"
};
export default ___CSS_LOADER_EXPORT___;
